type EducationListLoadingInput = {
  loading: boolean;
  hasUserCoursesError: boolean;
  loggedIn: boolean;
  rawUserCoursesCount: number;
  availableCoursesCount: number;
};

/** Keep the sidebar skeleton until user educations can be merged with the catalog. */
export function shouldShowEducationListSkeleton({
  loading,
  hasUserCoursesError,
  loggedIn,
  rawUserCoursesCount,
  availableCoursesCount,
}: EducationListLoadingInput): boolean {
  if (loading) {
    return true;
  }

  if (!loggedIn || hasUserCoursesError) {
    return false;
  }

  return rawUserCoursesCount > 0 && availableCoursesCount === 0;
}
